// Email
// This is a generic mailer for sending
// transactional emails to users

// For Documentation on the data object
// https://github.com/firebase/extensions/blob/master/firestore-send-email/POSTINSTALL.md

import store from '../store'
import firebase from 'firebase/app'
import 'firebase/functions'
let sendMail = firebase.functions().httpsCallable('sendMail')

const Email = {
  methods: {
    async email (data) {
      let result = await sendMail(data)
      return result
    },
    async emailToOwner (message) {
      let owner = store.state.channel.owner
      let result = await sendMail({
        toUids: [`${owner}`],
        message: message
      })
      return result
    },
    async emailToAdmin (message) {
      let result = await sendMail({
        to: 'admin@fanfolk.com',
        message: message
      })
      return result
    }
  }
}

export default Email
